import GoogleAd from ".";

const InArticleAd = () => {
  return (
    <GoogleAd
      adSlot="4411359626"
      adFormat="fluid"
      adStyle={{ width: "100%", textAlign: "center" }}
    />
  );
};

export default InArticleAd;
